import Modal from "components/Models/index";
import React, { useEffect, useState } from "react";
import Drawer from "components/Drawer/index";
import useScreenMobile from "hooks/useScreen";
import useTheme from "hooks/observer";
import { getTypeOfOp } from "@induz/sdk";
import "./showPermissions.scss";

const ShowPermissions = ({ role, handleCancel }) => {
    const theme = useTheme();
    const isMobile = useScreenMobile({ size: 992 });
    const [userControlOps, setUserControlOps] = useState([]);
    const [dataOps, setDataOps] = useState([]);
    const [auditOps, setAuditOps] = useState([]);
    const [secretOps, setSecretOps] = useState([]);
    const [spaceOps, setSpaceOps] = useState([]);
    const [activeTab, setActiveTab] = useState("userControlOps");

    useEffect(() => {
        setUserControlOps([]);
        setDataOps([]);
        setAuditOps([]);
        setSecretOps([]);
        setSpaceOps([]);

        role.operations.forEach(op => {
            if (op.role === "RestoreVersion") return;
            const opType = getTypeOfOp(op.role);
            if (opType === 0) setUserControlOps(prev => [...prev, op.role]);
            else if (opType === 1) setDataOps(prev => [...prev, op.role]);
            else if (opType === 2) setAuditOps(prev => [...prev, op.role]);
            else if (opType === 3) setSecretOps(prev => [...prev, op.role]);
            else if (opType === 4) setSpaceOps(prev => [...prev, op.role]);
        });
    }, [role]);

    const TABS = [
        { key: "userControlOps", label: "User Control" },
        { key: "dataOps", label: "Data" },
        { key: "auditOps", label: "Audit" },
        { key: "secretOps", label: "Secret" },
        { key: "spaceOps", label: "Space" },
    ];

    useEffect(() => {
        const tabData = { userControlOps, dataOps, auditOps, secretOps, spaceOps };
        const firstAvailableTab = TABS.find((tab) => tabData[tab.key]?.length > 0);
        setActiveTab(firstAvailableTab ? firstAvailableTab.key : "userControlOps");
    }, [userControlOps, dataOps, auditOps, secretOps, spaceOps]);

    const renderPermissionsList = () => {
        const isLight = theme === "light";

        const tabData = { userControlOps, dataOps, auditOps, secretOps, spaceOps };

        const availableTabs = TABS.filter(tab => tabData[tab.key]?.length);

        return (
            <div className={`show-permissions-wrapper ${isLight ? "light" : "dark"}`}>
                <div className={`tab-menu ${isLight ? "light" : "dark"}`}>
                    {availableTabs.map(tab => (
                        <button
                            key={tab.key}
                            onClick={() => setActiveTab(tab.key)}
                            className={`tab-button ${activeTab === tab.key ? "active" : ""}`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
                <div className="tab-content">
                    {(!tabData[activeTab] || tabData[activeTab].length === 0) ? (
                        <span className="no-permissions">No permissions</span>
                    ) : (
                        tabData[activeTab].map((op, idx) => (
                            <div key={idx} className="permission-label">
                                <span title={typeof op === "object" ? op.role : op}>
                                    {typeof op === "object" ? op.role : op}
                                </span>
                            </div>
                        ))
                    )}
                </div>
            </div>
        );
    };

    const roleLabel = (
        <span>
            Permissions for <span style={{ backgroundColor: "var(--gray-gray-8)", borderRadius: "5px", padding: "5px" }}>{role.roles}</span> Role
        </span>
    );

    return isMobile ? (
        <Drawer showFooter={false} handleCancel={handleCancel} isVisible={true} title="Permissions for role" heading={roleLabel}>
            {renderPermissionsList()}
        </Drawer>
    ) : (
        <Modal
            title="Permissions for role"
            heading={roleLabel}
            showFooter={false}
            showCross={true}
            handleCancel={handleCancel}
            padding="40px"
        >
            {renderPermissionsList()}
        </Modal>
    );
};

export default ShowPermissions;
